import { HttpClient, HttpParams } from '@angular/common/http';
import * as conf from '../@config/api';
import { Social } from '../@models/system-managment/social';
import { Functions } from '../../@util/functions';
import { FileUploadingService } from "../../@util/file-uploading-progress/file-uploading.service";
import { FormMode } from "../@models/system-managment/form-mode";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../@util/file-uploading-progress/file-uploading.service";
var SystemUsersService = /** @class */ (function () {
    function SystemUsersService(http, fileUploadingService) {
        this.http = http;
        this.fileUploadingService = fileUploadingService;
        this.config = conf.SYSTEM_USER_CONFIG;
    }
    SystemUsersService.prototype.addUser = function (user) {
        return this.http.post(this.config.add, user);
    };
    SystemUsersService.prototype.getUsersList = function (role) {
        var httpParams = new HttpParams();
        if (role !== null)
            httpParams = httpParams.append('role', role);
        return this.http.get(this.config.getAll, { params: httpParams });
    };
    SystemUsersService.prototype.mapUserStaff = function (data) {
        return data.map(function (j) {
            var thisLabel = '';
            if (!(j.personal && j.personal.firstName && j.personal.lastName)) {
                thisLabel = 'Fill Name';
            }
            else {
                thisLabel = j.personal.firstName + ' ' + j.personal.lastName;
            }
            if (j.personal && j.personal.title) {
                thisLabel = thisLabel + ', ' + j.personal.title;
            }
            else {
                thisLabel = thisLabel + ' ';
            }
            if (!j.contact || !j.contact.email) {
                thisLabel = thisLabel + '';
            }
            else {
                thisLabel = thisLabel + ' ~ ' + j.contact.email;
            }
            return {
                value: j.username,
                label: thisLabel
            };
        });
    };
    SystemUsersService.prototype.getCurrentUser = function (userId) {
        return this.http.get(this.config.getById(userId));
    };
    SystemUsersService.prototype.updatePasswordAndActive = function (value) {
        return this.http.post(this.config.updateLoginInfo(value.username), value);
    };
    SystemUsersService.prototype.setContact = function (userName, value, formMode) {
        value.press = Functions.checkPhone(value.press);
        value.fax = Functions.checkPhone(value.fax);
        value.phone = Functions.checkPhone(value.phone);
        var url = formMode !== FormMode.SelfEdit ? this.config.setContact(userName) : this.config.selfEdit.setContact(userName);
        return this.http.post(this.config.setContact(userName), value);
    };
    SystemUsersService.prototype.setPersonal = function (userName, value, formMode) {
        value.phone = Functions.checkPhone(value.phone);
        ////console.log(formMode);
        var url = formMode !== FormMode.SelfEdit ? this.config.setPersonal(userName) : this.config.selfEdit.setPersonal(userName);
        return this.http.post(url, value);
    };
    SystemUsersService.prototype.setSocial = function (userName, value, formMode) {
        Social.checkLinck(value);
        var url = formMode !== FormMode.SelfEdit ? this.config.setSocial(userName) : this.config.selfEdit.setSocial(userName);
        return this.http.post(this.config.setSocial(userName), value);
    };
    SystemUsersService.prototype.uploadAvatar = function (username, avatar) {
        return this.fileUploadingService.uploadFile('/api/user/avatar/' + username, { file: avatar, fileInfo: null });
    };
    SystemUsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SystemUsersService_Factory() { return new SystemUsersService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.FileUploadingService)); }, token: SystemUsersService, providedIn: "root" });
    return SystemUsersService;
}());
export { SystemUsersService };
